import type { UseCase } from '@contexts/shared/application';
import { uuidValueObject } from '@contexts/shared/domain';
import type { UserRepository } from '@contexts/users/domain';

export type ResendActivationInput = {
	id: string;
};

export type ResendActivationCodeUseCase = UseCase<ResendActivationInput, void>;

export function resendActivationCodeBuilder(
	userRepository: UserRepository
): ResendActivationCodeUseCase {
	return async function resendActivationCode(input: ResendActivationInput): Promise<void> {
		const id = uuidValueObject().validate('id', input.id);

		return userRepository.resendActivationCode(id);
	};
}
